import { SET_TEMP_DATA } from "../action-types";

export const saveTemp = (data) => dispatch => {
    dispatch({ type: SET_TEMP_DATA, payload: data })
}
